import { APP_LOADING, TOGGLE_GLOBAL_TOAST } from '../actions/action-types';

// Define the allowed toast types as a union type
type ToastType = 'success' | 'info' | 'warning' | 'error';

interface IToast {
  visibility: boolean;
  label: string;
  type: ToastType;
  timeout?: number;
  traceId?: string;
}

interface IGlobalState {
  globalToast: IToast;
  appLoading: boolean;
}

const initialState: IGlobalState = {
  globalToast: {
    visibility: false,
    label: '',
    type: 'error',
  },
  appLoading: true,
};

// eslint-disable-next-line default-param-last
export default (state = initialState, action: any) => {
  switch (action.type) {
    case TOGGLE_GLOBAL_TOAST:
      return {
        ...state,
        globalToast: {
          visibility: false,
          label: '',
          type: 'error',
          ...action.payload,
        },
      };
    case APP_LOADING:
      return {
        ...state,
        appLoading: action.payload,
      };
    default:
      return state;
  }
};
